var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 8.67438L6.6513 12.7207C6.27885 13.0931 5.67499 13.0931 5.30254 12.7207C4.93009 12.3482 4.93009 11.7444 5.30254 11.3719L8.67444 8L5.30253 4.6281C4.93008 4.25565 4.93008 3.65179 5.30253 3.27934C5.67498 2.90689 6.27884 2.90689 6.65129 3.27934L10.6953 7.32333C10.6961 7.32409 10.6968 7.32486 10.6976 7.32562C11.07 7.69807 11.07 8.30193 10.6976 8.67438Z",
    fill: "#002240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.5616e3403cdb76f2583b3004290c57fe.svg";
export { ForwardRef as ReactComponent };